import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSubscriptionMutations } from "@/hooks/useSubscriptionMutations";
import { toast } from "@/hooks/use-toast";
import { PersonalRoutinesSection } from "./PersonalRoutinesSection";
import { PlansGrid } from "./components/PlansGrid";
import { Profile } from "@/hooks/profile/types";

interface PersonalPlansSectionProps {
  plans: any[];
  profile: Profile | null;
  openSection: string;
  setOpenSection: (section: string) => void;
  showForm: boolean;
  setShowForm: (show: boolean) => void;
  refetchPlans: () => void;
  routines: any[];
}

export const PersonalPlansSection = ({
  plans,
  profile,
  openSection,
  setOpenSection,
  showForm,
  setShowForm,
  refetchPlans,
  routines,
}: PersonalPlansSectionProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const { unsubscribeMutation } = useSubscriptionMutations();

  const handleTabChange = (value: string) => {
    setCurrentIndex(parseInt(value));
  };

  // Show only personal plans or subscribed/copied plans (not original public plans)
  const visiblePlans = plans.filter(plan => 
    plan.is_personal || plan.copied_from_plan_id !== null
  );

  const handleViewRoutines = (planId: string) => {
    navigate(`/rutina/plan/${planId}`);
  };

  const handleUnsubscribe = async (planId: string) => {
    try {
      await unsubscribeMutation.mutateAsync(planId);
      refetchPlans();
    } catch (error) {
      console.error('Error deleting plan copy:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo eliminar la copia del plan",
      });
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold mb-4">Mis Planes de Entrenamiento</h2>
      
      <PlansGrid
        plans={visiblePlans}
        onViewRoutines={handleViewRoutines}
        onUnsubscribe={handleUnsubscribe}
        isUnsubscribing={unsubscribeMutation.isPending}
      />

      {openSection === "routines" && (
        <PersonalRoutinesSection
          routines={routines}
          openSection={openSection}
          setOpenSection={setOpenSection}
          currentIndex={currentIndex}
          onTabChange={handleTabChange}
          refetchRoutines={refetchPlans}
          showInPlan={false}
        />
      )}
    </div>
  );
};